import { DropdownModel } from "./../../report/models/report-filter.model";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  NgZone
} from "@angular/core";
import {
  IKeyValueInterface,
  BookingStatus,
  Permission,
  PermissionType,
  WeGoAuthorizedLink,
  Entity
} from "./../../shared/config";
import { Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { Observable } from "rxjs/Observable";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL
} from "../../shared/config";
import { CostAndExpenseModel } from "../models/cost-expense.model";
import { CostAndExpenseService } from "../models/cost-expense.service";
import { VatSettingsModel } from "../../vat-setting/models/vat-settings.model";
import { BookingService } from "../../booking/models/booking.service";

const moment = require("moment");

@Component({
  selector: "confirm-costandexpense-popup",
  template: require('../views/confirm-costandexpense-popup.component.html'),
  providers: [CostAndExpenseService, BookingService],
  styles: [
    `
      .form-horizontal .control-label {
        text-align: left;
      }
      .image-expense {
            max-width: 100%;
            max-height: 350px;
      }
      .overlay-magnifier {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        background: rgba(0,0,0,0.2);
        align-items: center;
        justify-content: center;
      }
    `
  ]
})
export class ConfirmCostAndExpenseComponent implements OnInit {
  urlBookingInfo: string;
  viewBookingLink: WeGoAuthorizedLink;
  vatSettingList: DropdownModel[];
  organizationList: any;
  costTypeList: any;
  urlPersonInfo: string;
  viewPersonLink: any;
  apiErrorMsg: any;
  model: CostAndExpenseModel;
  vatSettingDefaultCost: boolean;

  public isLoading: boolean;
  public headers: any;
  public errorModel: IKeyValueInterface[];
  public errorMsg: string;

  @ViewChild("approvalCostAndExpenseModel") approvalCostAndExpenseModel: any;
  @ViewChild("receiptImagePopup") receiptImagePopup: any;

  @Output("OnSuccessSave") onSuccessSave = new EventEmitter();
  @Output("OnSuccessSelect") OnSuccessSelect = new EventEmitter();
  @Output("OnHidden") OnHidden = new EventEmitter();

  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private zone: NgZone,
    private costAndExpenseService: CostAndExpenseService,
    private bookingService: BookingService
  ) {}

  // @Input()
  // set model(_costAndExpenseModel: CostAndExpenseModel) {
  //   this._model = _costAndExpenseModel;
  // }
  // get model() {
  //   return this._model;
  // }

  ngOnInit() {
    this.urlPersonInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_UPDATE
    );

    this.urlBookingInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION
    );
  }

  public show(model: CostAndExpenseModel): void {
    this.errorMsg = "";
    this.errorModel = [];

    this.model = JSON.parse(JSON.stringify(model));

    this.viewPersonLink = new WeGoAuthorizedLink(
      this.urlPersonInfo + "/" + this.model.reportedByPersonHashId,
      Permission.PR_PERSON_OVERVIEW,
      PermissionType.EDIT,
      "",
      this.model.reportedByName,
      "",
      "",
      true
    );

    this.viewBookingLink = new WeGoAuthorizedLink(
      this.urlBookingInfo + "/" + this.model.bookingHashId,
      Permission.PR_BOOKINGS_OVERVIEW,
      PermissionType.VIEW,
      "",
      this.model.bookingReferenceID,
      "",
      "",
      true
    );

    this.approvalCostAndExpenseModel.show();
    this.GetCostTypeList();
  }

  public GetCostTypeList() {
    this.costAndExpenseService
      .GetDropdownCostTypeList(this.model.reportedByPersonHashId)
      .subscribe(
        res => {
          this.costTypeList = res.data;
          this.GetOrganizationList();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetOrganizationList() {
    this.costAndExpenseService
      .GetDropdownOrganizationList(
        this.model.reportedByPersonHashId,
        this.model.reportedByDriver
      )
      .subscribe(
        res => {
          this.organizationList = res.data;
          this.GetVatSettingDropdownList();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public hide(): void {
    this.model = new CostAndExpenseModel();
    this.approvalCostAndExpenseModel.hide();
  }

  public GetVatSettingDropdownList() {
    if (this.model.bookingHashId) {
      this.bookingService
        .GetVatSettingDropdownList(this.model.bookingHashId)
        .subscribe(
          res => {
            if (res.data) {
              this.vatSettingList = res.data;
              //this.GetVatSettingDefaultValues();
            } else {
              this.apiErrorMsg = res.error;
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    }
  }

  public GetVatSettingDefaultValues() {
    this.bookingService
      .GetVatSettingDefaultValues(this.model.bookingHashId)
      .subscribe(
        res => {
          if (res.data) {
            const vatSettingDefaultValues = res.data;
            this.vatSettingDefaultCost =
              vatSettingDefaultValues.vatSettingDefaultCost;
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.errorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  private OnSuccessSave() {
    this.isLoading = false;
    this.OnSuccessSelect.emit({ CostAndExpenseModel: this.model });
    this.hide();
    let successMsg = this.translate.instant("LblSuccess");
    this.onSuccessSave.emit({ SuccessMessage: successMsg });
  }

  public OnApprove() {
    this.isLoading = true;

    this.costAndExpenseService.AcceptReject(this.model, true, false).subscribe(
      res => {
        if (res.data) {
          this.OnSuccessSave();
        } else {
          this.errorModel = res.error;
        }
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnReject() {
    this.isLoading = true;

    this.costAndExpenseService.AcceptReject(this.model, false, true).subscribe(
      res => {
        if (res.data) {
          this.OnSuccessSave();
        } else {
          this.errorModel = res.error;
        }
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ApprovedAmtExVatChange() {
    if (this.model.approvedAmountExVat && this.model.approvedVatPercentage) {
      this.model.approvedAmountInVat =
        parseFloat(this.model.approvedAmountExVat.toString()) +
        parseFloat(this.model.approvedAmountExVat.toString()) *
          parseFloat(this.model.approvedVatPercentage.toString()) /
          100;

      this.model.approvedAmountInVat =
        Math.round(this.model.approvedAmountInVat * 100) / 100;
    }
  }

  public ApprovedVatChange() {
    this.ApprovedAmtExVatChange();
  }

  public ApprovedAmtInVatChange() {
    if (this.model.approvedAmountInVat && this.model.approvedVatPercentage) {
      this.model.approvedAmountExVat = this.GetBasevalueFromPercentage(
        parseFloat(this.model.approvedAmountInVat.toString()),
        parseFloat(this.model.approvedVatPercentage.toString())
      );

      this.model.approvedAmountExVat =
        Math.round(this.model.approvedAmountExVat * 100) / 100;
    }
  }

  public GetBasevalueFromPercentage(
    FinalValue: number,
    Percentage: number
  ): number {
    return FinalValue * 100 / (100 + Percentage);
  }

  public GetImagePath(path: string) {
    return WeGoConfig.API_SERVER_URL + path;
  }

  public ShowReceipt(imagepath: string) {
    this.receiptImagePopup.imagepath = imagepath;
    this.receiptImagePopup.show();
  }  

  public onHidden($event:any)
  {
    this.OnHidden.emit();
  }

  public SetVatDefaultCost(vatSettingDefaultCost: boolean) {
    return vatSettingDefaultCost
      ? this.translate.instant('LblExcludingVat')
      : this.translate.instant('LblIncludingVat');
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/cost-expenses/components/confirm-costandexpense-popup.component.ts